import React from 'react';
interface CTAButtonProps {
  text: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text,
  href = '#compra',
  className = ''
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (href.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <a href={href} onClick={handleClick} className={`
        relative block w-full max-w-xl mx-auto text-center
        bg-[#22c55e] hover:bg-[#16a34a] text-white 
        font-extrabold text-xl md:text-2xl 
        py-5 px-6 rounded-xl
        shadow-[0_0_20px_rgba(34,197,94,0.6)]
        transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(34,197,94,0.8)]
        animate-[pulse_2s_ease-in-out_infinite]
        ${className}
      `} data-id="element-4">
      {text}
    </a>;
}